import { getCtUserDefinedFields, inBoolean, inFile, inSelect } from './advanceQueryEntries'
import { getLocalizedOptions, getOperatorsByQueryType, groupEntriesByCt, searchInStaticData } from './helper'
import groupBy from 'lodash/groupBy'

const inOperator = {
  group: '',
  queryType: 'inOperator',
  type: 'operator',
  options: []
}

const contentTypeLabel = {
  group: '',
  queryType: 'contentTypeLabel',
  type: 'key',
  options: [{ label: 'Content Type', value: '_content_type_uid' }]
}

const inContentType = {
  group: '',
  queryType: 'contentTypeLabel',
  type: 'value',
  options: []
}

export const languageLabel = {
  group: '',
  queryType: 'languageLabel',
  type: 'key',
  options: [{ label: 'Language', value: 'locale' }]
}

const inLanguage = {
  group: '',
  queryType: 'languageLabel',
  type: 'value',
  options: []
}

const userLabel = {
  group: '',
  queryType: 'userLabel',
  type: 'key',
  options: [
    { label: 'Created By', value: 'created_by' },
    { label: 'Updated By', value: 'updated_by' },
    { label: 'Published By', value: '_published_by' }
  ]
}

const inUser = {
  group: '',
  queryType: 'userLabel',
  type: 'value',
  options: []
}

const dateLabel = {
  group: '',
  queryType: 'dateLabel',
  // nextQuery: 'inDate',
  type: 'key',
  options: [
    { label: 'Created At', value: 'created_at' },
    { label: 'Updated At', value: 'updated_at' },
    { label: 'Published At', value: '_published_at' }
  ]
}

const environmentLabel = {
  group: '',
  queryType: 'environmentLabel',
  type: 'key',
  options: [{ label: 'Published Environment', value: '_publish_environment' }]
}

const inEnvironment = {
  group: '',
  queryType: 'environmentLabel',
  type: 'value',
  options: []
}

const entriesTagLabel = {
  group: '',
  queryType: 'entriesTagLabel',
  type: 'key',
  options: [{ label: 'Tag', value: 'tags' }]
}

const draftStatusLabel = {
  group: '',
  queryType: 'booleanLabel',
  type: 'key',
  options: [{ label: 'Draft', value: '_is_draft' }]
}

const inEntriesTag = {
  group: '',
  queryType: 'entriesTagLabel',
  type: 'value',
  options: []
}

const uidLabel = {
  group: '',
  queryType: 'uidLabel',
  // nextQuery: 'inText',
  type: 'key',
  options: [{ label: 'UID', value: 'uid' }]
}

const workflowLabel = {
  group: '',
  queryType: 'workflowLabel',
  // nextQuery: 'inWorkflow',
  type: 'key',
  options: [{ label: 'Workflow Stage', value: '_workflow' }]
}

const inWorkflow = {
  group: '',
  queryType: 'inWorkflow',
  type: 'value',
  options: []
}

const systemDefinedLabel = {
  group: 'System-defined Fields',
  options: []
}

//localization options suggestion
export const localizedInLabel = {
  group: '',
  queryType: 'localizedInLabel',
  type: 'operator',
  options: [
    { label: 'Localized In', value: '$localization' },
    { label: 'Not Localized In', value: '$notLocalization' }
  ]
}

const inLocalized = {
  group: '',
  queryType: 'localizedInLabel',
  type: 'value',
  options: []
}

const taxonomyTermLabel = {
  group: '',
  queryType: 'taxonomyTermLabel',
  type: 'key',
  options: [{ label: 'Taxonomy-Term', value: 'taxonomies' }]
}

const inTaxonomyTermLabel = {
  group: '',
  queryType: 'taxonomyTermLabel',
  type: 'value',
  options: []
}

const advSearchTextLabel = {
  group: '',
  queryType: 'advSearchTextLabel',
  type: 'key',
  options: [{ label: 'Text', value: 'search' }]
}

//todo enable for title && URL
const systemDefTitleLabel = {
  group: '',
  queryType: 'systemDefTitleLabel',
  type: 'key',
  options: [{ label: 'Title', value: 'title' }]
}

const systemDefUrlLabel = {
  group: '',
  queryType: 'systemDefUrlLabel',
  type: 'key',
  options: [{ label: 'URL', value: 'url' }]
}

const handleInitForAdvanceQuery = async (
  ct_status,
  inputValue,
  fetchSingleContentType,
  fetchWorkflowByCtUids,
  isTaxonomyPlanEnabled,
  isAutoDraftEnabled
) => {
  try {
    let staticQueryData = JSON.parse(
      JSON.stringify([
        contentTypeLabel,
        //todo enable for title && URL
        systemDefTitleLabel,
        systemDefUrlLabel,
        userLabel,
        environmentLabel,
        dateLabel,
        languageLabel,
        entriesTagLabel,
        ...(isAutoDraftEnabled ? [draftStatusLabel] : []),
        uidLabel,
        workflowLabel
      ])
    )

    if (isTaxonomyPlanEnabled) {
      staticQueryData = [...staticQueryData, taxonomyTermLabel]
    }

    const isCtObjectExist = ct_status && typeof ct_status === 'object'
    if (isCtObjectExist && ct_status.show_ct) {
      // console.log('show ct case', ct_status)
      staticQueryData = [...staticQueryData]
    } else if (isCtObjectExist && ct_status.isMullti && false) {
      // remove this condition for workflow state as its moved to root level
      staticQueryData = staticQueryData.slice(1)

      const ctUids = ct_status.ct_uid
      // console.log('ct_status.isMullti case', ctUids)
      const response = await fetchWorkflowByCtUids(ctUids)
      if (response && response.count) {
        const options = [{ label: 'Workflow Stage', value: '_workflow', valueOptions: response.data }]
        const workflow = { ...workflowLabel, options }
        staticQueryData = [...staticQueryData, workflow]
      }
    } else if (isCtObjectExist && !ct_status.isMullti && ct_status.ct_uid) {
      // const response = await fetchSingleContentType(ct_status.ct_uid)

      const ctUid = ct_status.ct_uid
      const [singleCtResponse] = await Promise.all([
        //workflowResponse
        fetchSingleContentType(ctUid)
        //fetchWorkflowByCtUids([ctUid])
      ])

      staticQueryData = [
        //todo enable for title && URL
        systemDefTitleLabel,
        systemDefUrlLabel,
        userLabel,
        environmentLabel,
        dateLabel,
        languageLabel,
        entriesTagLabel,
        draftStatusLabel,
        uidLabel,
        workflowLabel
      ]

      // if (workflowResponse && workflowResponse.count) {
      //   const options = [{ label: 'Workflow Stage', value: '_workflow', valueOptions: workflowResponse.data }]
      //   const workflow = { ...workflowLabel, options }
      //   staticQueryData = [...staticQueryData, workflow]
      // }

      if (isTaxonomyPlanEnabled) {
        staticQueryData = [...staticQueryData, taxonomyTermLabel]
      }

      if (singleCtResponse && singleCtResponse.content_type && singleCtResponse.content_type.schema) {
        const userDefinedFields = getCtUserDefinedFields(singleCtResponse.content_type.schema, [], '', '')
        userDefinedFields[0].group = 'USER DEFINED FIELDS'
        staticQueryData = [...staticQueryData, ...userDefinedFields]
      }
    } else {
      console.log('==> content type not selected')
    }

    // filter out and keep status of whether contentTypeLabel present in staticQueryData or not
    //  if present then only add contentTypeLabel at the top of array
    const foundCtLabelIndex = staticQueryData.findIndex(
      (eachQueryData) => eachQueryData.queryType == 'contentTypeLabel'
    )

    if (foundCtLabelIndex !== -1) {
      staticQueryData.splice(foundCtLabelIndex, 1)
      staticQueryData = [
        JSON.parse(JSON.stringify(contentTypeLabel)),
        advSearchTextLabel,
        systemDefinedLabel,
        ...staticQueryData
      ]
    } else {
      staticQueryData = [advSearchTextLabel, systemDefinedLabel, ...staticQueryData]
    }

    let searchResponse = searchInStaticData(staticQueryData, inputValue)
    console.log('🚀 ~ handleInitForAdvanceQuery ~ searchResponse:', searchResponse)
    return searchResponse
  } catch (error) {
    console.log('handleInitForAdvanceQuery -> error', error)
    throw error
  }
}

export const suggestForEntries = async (data) => {
  try {
    let {
      queryType,
      fetchData,
      inputValue = '',
      skip,
      limit,
      currentQuery,
      type,
      ct_status,
      isTaxonomyPlanEnabled,
      isAutoDraftEnabled
    } = data
    const { key = [], operator = [], value = [] } = currentQuery
    // console.log('suggestForEntries ~ data:', data)

    let queryData: any = []
    let withOperator = true
    let count = 0
    let operators = getOperatorsByQueryType(queryType, key)
    let afterKey = false

    //this will be available as valueOption on key for userdef field
    let selectedOption = key[0]

    if ((type === 'operator' || type === 'value') && !key.length) {
      return { queryData: [], count: 0 }
    }

    //init case
    if (type === 'key') {
      const searchResponse = await handleInitForAdvanceQuery(
        ct_status,
        inputValue,
        fetchData.fetchSingleContentType,
        fetchData.fetchWorkflowByCtUids,
        isTaxonomyPlanEnabled,
        isAutoDraftEnabled
      )
      return { queryData: searchResponse.data, count: searchResponse.count, withOperator }
    }

    if (type === 'operator' && queryType === 'localizedInLabel') {
      queryData = [localizedInLabel]
      count = 2
      return { queryData, count, withOperator }
    }

    if (type === 'operator') {
      queryData = [{ ...inOperator, options: operators }]
      count = operators.length
      return { queryData, count, withOperator }
    }

    switch (queryType) {
      case 'contentTypeLabel': {
        const response: any = await fetchData.fetchContentTypes({
          skip,
          limit,
          inputValue
        })
        if (inputValue.trim() !== '') {
          const freeText = { label: inputValue, value: inputValue, type: 'text' }
          inContentType.options =
            operator.length && operator[0]?.value === 'contains' ? [freeText, ...response.data] : response.data
          count = response.count + 1
        } else {
          inContentType.options = response.data
          count = response.count
        }
        queryData = [inContentType]
        break
      }

      case 'environmentLabel': {
        const response: any = await fetchData.fetchEnvironments({ skip, limit, inputValue })
        inEnvironment.options = response.data
        count = response.count
        queryData = [inEnvironment]
        break
      }

      case 'localizedInLabel': {
        const response: any = await fetchData.fetchLanguages({})
        const localizedOptions = getLocalizedOptions({
          languages: response.data,
          selectedLanguageValue: currentQuery.selectedLanguage
        })
        inLocalized.options = localizedOptions

        queryData = [inLocalized]
        withOperator = true
        count = localizedOptions.length
        break
      }

      case 'languageLabel': {
        const response: any = await fetchData.fetchLanguages({ skip, limit, inputValue })
        const hasAllLanguages = response.data.filter((lang) => lang.value == '$allLanguages')
        if (!hasAllLanguages.length && operator[0]?.value == '$eq') {
          response.data.unshift({ label: 'All Languages', value: '$allLanguages' })
        } else if (hasAllLanguages.length && operator[0]?.value != '$eq') {
          response.data.shift()
        }
        inLanguage.options = response.data
        count = response.count
        queryData = [inLanguage]
        break
      }

      case 'entriesTagLabel': {
        const response: any = await fetchData.fetchEntriesTags({ skip, limit, inputValue })
        let filteredTags = response.data
        //searching tag here as backend does not support searching for tag
        // if (inputValue) {
        //   filteredTags = filteredTags.filter((tag) => {
        //     return tag.label.toLowerCase().includes(inputValue.toLowerCase())
        //   })
        // }
        // filteredTags = sortBy(filteredTags, (tag) => tag.label)
        inEntriesTag.options = filteredTags
        count = response.count
        queryData = [inEntriesTag]
        afterKey = response?.afterKey ? true : false
        break
      }

      case 'userLabel': {
        const response: any = await fetchData.fetchUsers({ skip, limit, inputValue })
        inUser.options = response.data
        count = response.count
        queryData = [inUser]
        break
      }

      // case 'workflowLabel': {
      //   inWorkflow.options = selectedOption.valueOptions
      //   queryData = [inWorkflow]
      //   count = selectedOption.valueOptions.length
      //   break
      // }

      case 'workflowLabel': {
        const isCtObjectExist = ct_status && typeof ct_status === 'object'

        const isSingleCTSelected = isCtObjectExist && !ct_status.isMullti && ct_status.ct_uid

        const response = isSingleCTSelected
          ? await fetchData.fetchWorkflowByCtUids([ct_status.ct_uid])
          : await fetchData.fetchWorkflowStage({ skip, limit, inputValue })

        let filteredStages = response.data
        if (inputValue) {
          filteredStages = filteredStages.filter((stage) => {
            return (
              stage.label.toLowerCase().includes(inputValue.toLowerCase()) ||
              stage.workflowName.toLowerCase().includes(inputValue.toLowerCase())
            )
          })
        }

        const groupedObj = groupBy(filteredStages, (data) => {
          return [data.workflowName]
        })
        let data: any = []
        Object.keys(groupedObj).forEach((k) => {
          const valueArray = groupedObj[k]
          valueArray.unshift({ group: k, value: k })
          data = [...data, ...valueArray]
        })

        inWorkflow.options = data
        queryData = [inWorkflow]
        count = filteredStages.length
        break
      }

      case 'selectLabel': {
        let allDropdownOptions = selectedOption.valueOptions

        if (inputValue) {
          allDropdownOptions = allDropdownOptions.filter((option) => {
            return option.label.toLowerCase().includes(inputValue.toLowerCase())
          })
        }
        inSelect.options = allDropdownOptions
        queryData = [inSelect]
        // console.log('selectLabel queryData', queryData)
        count = selectedOption.valueOptions.length
        break
      }

      case 'customFieldBooleanLabel':
      case 'booleanLabel': {
        queryData = [inBoolean]
        count = 2
        break
      }

      // case 'customFieldFileLabel':
      case 'fileLabel': {
        const response: any = await fetchData.fetchAssets({ skip, limit, inputValue })
        inFile.options = response.data
        count = response.count
        queryData = [inFile]
        break
      }

      // case 'customFieldReferenceLabel':
      case 'referenceLabel': {
        const valueOptions = selectedOption.valueOptions
        const query = { _content_type_uid: { $in: valueOptions } }
        const response: any = await fetchData.fetchEntries({ inputValue, query, skip, limit })
        const data = groupEntriesByCt(response)
        queryData = [...data]
        count = response.count
        break
      }
      case 'taxonomyTermLabel': {
        const response: any = await fetchData.fetchTaxonomies({ skip, limit, inputValue })
        let filteredTaxonomies = response?.taxonomies ? response.taxonomies : response?.terms ? response.terms : []
        if (inputValue) {
          filteredTaxonomies = filteredTaxonomies.filter((taxonomy) => {
            return taxonomy.label.toLowerCase().includes(inputValue.toLowerCase())
          })
        }
        inTaxonomyTermLabel.options = filteredTaxonomies
        count = response?.count
        queryData = [inTaxonomyTermLabel]
        break
      }
    }

    return { withOperator, queryData, count, afterKey: afterKey }
  } catch (error) {
    console.log('suggestForEntries ~ error:', error)
    throw error
  }
}
